var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: { actions: _vm.headerActions, page: _vm.page }
      }),
      _c("board", { staticClass: "mb-4", attrs: { details: _vm.board } }),
      _c(
        "validation-observer",
        {
          ref: "dispensationRequestRef",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c(
            "div",
            [
              _c("section-title", {
                attrs: { "has-line": true, title: "Información de la Dispensa" }
              }),
              _c("div", { staticClass: "row mb-3" }, [
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: !_vm.readOnly ? "required" : "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor de seleccionar la fecha desde.",
                                  disabled: _vm.readOnly,
                                  error: errors[0],
                                  label: "Fecha Desde:",
                                  "max-date": new Date(_vm.maxDateToValidate),
                                  "min-date": _vm.exemptionMinDate,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.dispensationInfo.selectedMinDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dispensationInfo,
                                      "selectedMinDate",
                                      $$v
                                    )
                                  },
                                  expression: "dispensationInfo.selectedMinDate"
                                }
                              }),
                              _vm.requiredValidRangeDate && errors[0] == null
                                ? _c("error", {
                                    attrs: {
                                      message: _vm.requiredValidRangeDate,
                                      variant: "no-border mt-2 ml-n1"
                                    }
                                  })
                                : _vm._e()
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: !_vm.readOnly ? "required" : "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-date-picker", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor de seleccionar la fecha hasta.",
                                  disabled: _vm.readOnly,
                                  error: errors[0],
                                  label: "Fecha Hasta:",
                                  "max-date": new Date(_vm.maxDateToValidate),
                                  "min-date": _vm.exemptionMinDate,
                                  placeholder: "DD/MM/YYYY"
                                },
                                model: {
                                  value: _vm.dispensationInfo.selectedMaxDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dispensationInfo,
                                      "selectedMaxDate",
                                      $$v
                                    )
                                  },
                                  expression: "dispensationInfo.selectedMaxDate"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row mb-4" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: !_vm.readOnly ? "required" : "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-text-area", {
                                attrs: {
                                  "custom-error-msg":
                                    "Favor de introducir un comentario.",
                                  disabled: _vm.readOnly,
                                  error: errors[0],
                                  label: "Comentario:",
                                  maxlength: 500
                                },
                                model: {
                                  value: _vm.dispensationInfo.exemptionComment,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dispensationInfo,
                                      "exemptionComment",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "dispensationInfo.exemptionComment"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.isDEPRRequest
            ? _c("dispense-documents", {
                ref: "dispenseDocumentsRef",
                attrs: {
                  "inner-exemption-files": _vm.dispensationInfo.exemptionFiles
                }
              })
            : [
                _c(
                  "div",
                  [
                    _c("section-title", {
                      attrs: {
                        "has-line": true,
                        title: `Información del Especialista${
                          _vm.isDeprExemption ? "" : " Supervisor"
                        }`
                      }
                    }),
                    _c(
                      "callout",
                      {
                        attrs: {
                          "border-color": "primary-2",
                          "class-main": "bg-white border-bottom mb-4",
                          "has-toggle": false
                        }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-5" },
                            [
                              _c("p", [
                                _vm._v(
                                  " Describa si bajo su corporación realiza las siguientes labores: "
                                )
                              ]),
                              _vm.hasSameCorpRoles &&
                              _vm.requiredSameCorpRolMessage
                                ? _c("error", {
                                    attrs: {
                                      message: _vm.requiredSameCorpRolMessage,
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-7 d-flex" },
                            _vm._l(_vm.specialistSupervisorTaskOne, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: `task_one_${index}`,
                                  staticClass: "col-sm"
                                },
                                [
                                  _c("check-box", {
                                    attrs: {
                                      disabled: _vm.readOnly,
                                      text: item.name
                                    },
                                    model: {
                                      value: item.checked,
                                      callback: function($$v) {
                                        _vm.$set(item, "checked", $$v)
                                      },
                                      expression: "item.checked"
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _c(
                      "callout",
                      {
                        attrs: {
                          "border-color": "primary-2",
                          "class-main": "bg-white border-bottom mb-4",
                          "has-toggle": false
                        }
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-5" },
                            [
                              _c("p", [
                                _vm._v(
                                  " Describa cual de las siguientes labores realiza bajo otra corporación: "
                                )
                              ]),
                              _vm.hasOtherCorpRoles &&
                              _vm.requiredOtherCorpRolMessage
                                ? _c("error", {
                                    attrs: {
                                      message: _vm.requiredOtherCorpRolMessage,
                                      variant: "no-border"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-7 d-flex" },
                            _vm._l(_vm.specialistSupervisorTaskTwo, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: `task_two_${index}`,
                                  staticClass: "col-sm"
                                },
                                [
                                  _c("check-box", {
                                    attrs: {
                                      disabled: _vm.readOnly,
                                      text: item.name
                                    },
                                    model: {
                                      value: item.checked,
                                      callback: function($$v) {
                                        _vm.$set(item, "checked", $$v)
                                      },
                                      expression: "item.checked"
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "container-fluid mb-4 bg-secondary-13 py-2 rounded"
                      },
                      [
                        _c("div", { staticClass: "row border-bottom mt-3" }, [
                          _c("div", { staticClass: "col-sm" }, [
                            _c("p", { staticClass: "data-name" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    `Total de matrícula${
                                      _vm.isDeprExemption
                                        ? ""
                                        : " del supervisor"
                                    } en su corporación:`
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "data" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dispensationInfo.supervisorInfo !=
                                        undefined
                                        ? _vm.dispensationInfo.supervisorInfo
                                            .serviceTotal
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "col-sm" }, [
                            _c("p", { staticClass: "data-name" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    `Total de matrícula ${
                                      _vm.isDeprExemption
                                        ? ""
                                        : " del supervisor"
                                    } incluyendo otras corporaciones:`
                                  ) +
                                  " "
                              ),
                              _c("span", { staticClass: "data" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dispensationInfo.supervisorInfo !=
                                        undefined
                                        ? _vm.dispensationInfo.supervisorInfo
                                            .corpServiceTotal
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("p", { staticClass: "data-name" }, [
                              _vm._v(" Especialidades: "),
                              _c("span", { staticClass: "data" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.dispensationInfo.supervisorInfo !=
                                        undefined
                                        ? _vm.dispensationInfo
                                            .specialistSpecialtyTypeNames
                                        : "-"
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c("section-title", {
                  attrs: {
                    "has-line": true,
                    title: `Información de Especialistas${
                      _vm.isDeprExemption ? "" : " Supervisados"
                    }`
                  }
                }),
                _c("supervised", {
                  attrs: {
                    "dispense-request-list":
                      _vm.dispensationInfo.exemptionRequestSpecialistDetail,
                    "supervised-other-corporation-list":
                      _vm.dispensationInfo
                        .exemptionRequestSupervisorOtherCompanyDetail,
                    "supervisor-info": _vm.dispensationInfo.supervisorInfo
                  }
                }),
                _vm.dispensationInfo?.exemptionFiles?.length
                  ? _c(
                      "div",
                      [
                        _c("section-title", {
                          staticClass: "mt-3",
                          attrs: {
                            "has-line": true,
                            title: "Documentos de Respaldo"
                          }
                        }),
                        _vm._l(_vm.dispensationInfo.exemptionFiles, function(
                          exemptionFile
                        ) {
                          return _c(
                            "div",
                            { key: exemptionFile.fileId },
                            [
                              _c(
                                "callout",
                                {
                                  attrs: {
                                    "class-main": "mb-2 py-3",
                                    "has-toggle": false
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 d-flex justify-content-between"
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "exemption-file__title"
                                          },
                                          [_vm._v("Documento")]
                                        ),
                                        _c("p", [
                                          _vm._v(_vm._s(exemptionFile.name))
                                        ])
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-end"
                                        },
                                        [
                                          _c("CustomFileInput", {
                                            attrs: {
                                              accept: ".pdf",
                                              "add-text":
                                                "Presione aquí para añadir Documento",
                                              "attachment-id":
                                                exemptionFile.fileId,
                                              "can-delete": false,
                                              disabled: true,
                                              "display-style": "normal",
                                              "is-edit": true,
                                              name: exemptionFile.fileName,
                                              "on-download": () => {}
                                            },
                                            model: {
                                              value: exemptionFile.file,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  exemptionFile,
                                                  "file",
                                                  $$v
                                                )
                                              },
                                              expression: "exemptionFile.file"
                                            }
                                          }),
                                          _c(
                                            "div",
                                            [
                                              _vm.userHasPermissions(
                                                "provider.dispenseManagement.replacedocument"
                                              )
                                                ? _c("action-button", {
                                                    staticClass:
                                                      "btn mr-2 ml-2 p-0 button-container",
                                                    attrs: {
                                                      i: "fas fa-undo-alt ml-2",
                                                      variant: "outline-success"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onReplaceFileHandler(
                                                          `fileRef-${exemptionFile.fileId}`
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _c("input", {
                                                ref: `fileRef-${exemptionFile.fileId}`,
                                                refInFor: true,
                                                staticStyle: {
                                                  display: "none"
                                                },
                                                attrs: {
                                                  id: `file-${exemptionFile.fileId}`,
                                                  accept: ".pdf",
                                                  type: "file"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.onUploadFileHandler(
                                                      exemptionFile.id,
                                                      `fileRef-${exemptionFile.fileId}`
                                                    )
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }